import { render, staticRenderFns } from "./property-wallet-page.vue?vue&type=template&id=ff7a45a4&scoped=true&"
import script from "./property-wallet-page.vue?vue&type=script&lang=js&"
export * from "./property-wallet-page.vue?vue&type=script&lang=js&"
import style0 from "./property-wallet-page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./property-wallet-page.vue?vue&type=style&index=1&id=ff7a45a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7a45a4",
  null
  
)

export default component.exports